import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0b758829")

_pushScopeId("data-v-0b758829")
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { "aria-label": "breadcrumb" }
const _hoisted_3 = { class: "breadcrumb breadcrumb-custom" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_ctx.lista.length > 0)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("nav", _hoisted_2, [
          _createVNode("ol", _hoisted_3, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.lista, (breadcrumb, index) => {
              return (_openBlock(), _createBlock("li", {
                class: ["breadcrumb-item", { active: index == _ctx.lista.length }],
                key: index
              }, [
                _createVNode(_component_router_link, {
                  to: breadcrumb.link
                }, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(breadcrumb.title), 1)
                  ]),
                  _: 2
                }, 1032, ["to"])
              ], 2))
            }), 128))
          ])
        ])
      ]))
    : _createCommentVNode("", true)
})